'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusTrapReact = require('focus-trap-react');

var _focusTrapReact2 = _interopRequireDefault(_focusTrapReact);

var _Modal = require('./Modal.css');

var _Modal2 = _interopRequireDefault(_Modal);

var _ModalGlobal = require('./ModalGlobal.css');

var _ModalGlobal2 = _interopRequireDefault(_ModalGlobal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Modal = function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal() {
    _classCallCheck(this, Modal);

    return _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).apply(this, arguments));
  }

  _createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.body.classList.remove('no-scroll');
      if (this.props.modalOpen) {
        document.body.classList.add('no-scroll');
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      document.body.classList.remove('no-scroll');
      if (nextProps.modalOpen) {
        document.body.classList.add('no-scroll');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var modalClasses = [''];
      if (this.props.modalOpen) {
        modalClasses.push('modal');
      }
      if (this.props.portrait) {
        modalClasses.push('portrait-modal');
      }
      var modalClassList = modalClasses.join(' ');

      return _react2.default.createElement(
        'div',
        {
          onClick: this.props.modalOpen ? this.props.handleCloseClick : null,
          role: 'presentation',
          className: 'jsx-' + _Modal2.default.__scopedHash + ' ' + ((this.props.modalOpen ? 'background' : '') || '')
        },
        _react2.default.createElement(
          _focusTrapReact2.default,
          {
            focusTrapOptions: {
              allowOutsideClick: true
            },
            active: this.props.modalOpen
          },
          _react2.default.createElement(
            'div',
            { 'aria-modal': 'true', className: 'jsx-' + _Modal2.default.__scopedHash + ' ' + (modalClassList || '')
            },
            _react2.default.createElement(
              'div',
              {
                className: 'jsx-' + _Modal2.default.__scopedHash + ' ' + ((this.props.modalOpen ? 'close' : 'hidden') || '')
              },
              _react2.default.createElement('button', {
                onClick: this.props.handleCloseClick,
                'aria-label': 'close',
                className: 'jsx-' + _Modal2.default.__scopedHash + ' ' + 'button'
              })
            ),
            _react2.default.createElement(
              'div',
              {
                onClick: function onClick(e) {
                  return e.stopPropagation();
                },
                role: 'presentation',
                className: 'jsx-' + _Modal2.default.__scopedHash + ' ' + 'content'
              },
              this.props.children
            )
          )
        ),
        _react2.default.createElement(_style2.default, {
          styleId: _Modal2.default.__scopedHash,
          css: _Modal2.default.__scoped
        }),
        _react2.default.createElement(_style2.default, {
          styleId: _ModalGlobal2.default.__hash,
          css: _ModalGlobal2.default
        })
      );
    }
  }]);

  return Modal;
}(_react2.default.Component);

Modal.propTypes = {
  children: _propTypes2.default.node.isRequired,
  handleCloseClick: _propTypes2.default.func.isRequired,
  modalOpen: _propTypes2.default.bool.isRequired,
  portrait: _propTypes2.default.bool
};

Modal.defaultProps = {
  portrait: false
};

exports.default = Modal;